import React from 'react';
import { Button as AntdButton } from 'antd';

import { FormButtonProps } from 'app/components/common/buttons/form-button/form-button-props';

type Props = FormButtonProps;

const Button: React.FC<Props> = (props: Props) => {
    const { submitting, disabled, ...rest } = props;

    return <AntdButton htmlType="button" disabled={disabled || submitting} {...rest} />;
};

export { Button };
